import Sidebar from './Sidebar.container';

export default Sidebar;
